const baseUrl = 'https://test-ret.septima.dk/api/';
export default {
  postVejkodeOpdatering (postData, token) {
    return fetch(`${baseUrl}vejkode`,
      {
        method: 'POST',
        headers: new Headers({
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json; charset=utf-8',
        }),
        body: JSON.stringify(postData),
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        return response;
      })
      .catch(function (err) {
        throw err;
      });
  },
};
